import BlockOutlined from '@mui/icons-material/BlockOutlined';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {
  Box,
  Button,
  Chip,
  Collapse,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography
} from '@mui/material';
import { NfcCard } from 'graphql/generated/graphqlTypes';
import { Translation } from 'hooks/useTranslation/useTranslation';
import React, { useState } from 'react';
import { getActionArray, getCardStatusesArray } from 'utils/NfcCard/nfcCard';
import { formatDate } from 'v2/utils/dateTime';

interface Props {
  index: number;
  card: NfcCard;
  translation: Translation;
  onBlockCard: (cardUuid: string) => void;
}

const NfcCardRow: React.FC<Props> = ({ index, card, translation, onBlockCard }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Grid container direction="column" spacing={0.5} id={`nfc-card-row-${index}`}>
      <ListItemButton
        id={`nfc-card-row-${index}-toggle-button`}
        onClick={() => setIsOpen(!isOpen)}
        sx={{ gap: '8px', backgroundColor: (theme) => theme.custom.background.level2, borderRadius: 1 }}
      >
        <Grid container direction="row" wrap="nowrap" justifyContent="space-between" alignItems="center" width="100%">
          <Stack
            direction="row"
            flexWrap="wrap"
            justifyContent="space-between"
            alignItems="center"
            flex={1}
            minWidth={0}
            rowGap={0.5}
            columnGap={1}
          >
            <Box minWidth={0} overflow="hidden">
              <ListItemText
                primary={
                  <Typography variant="body1" noWrap>
                    {translation.access_cards}
                  </Typography>
                }
              />
            </Box>
            <ListItemIcon sx={{ minWidth: 0, flexShrink: 0 }}>
              <Chip label={card.uuid} size="small" />
            </ListItemIcon>
          </Stack>
          {isOpen ? <ExpandLess /> : <ExpandMore />}
        </Grid>
      </ListItemButton>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Grid container direction="row" wrap="nowrap" justifyContent="center" alignItems="center" width="100%">
          <List component="div" disablePadding>
            <ListItem sx={{ pl: 4 }}>
              <Grid container direction="column">
                <Grid container spacing={1}>
                  <Typography color="text.primary">{`${translation.card} #`}</Typography>
                  <Typography color="text.secondary">{card.uuid}</Typography>
                </Grid>
                {card.assignment?.expiryDate && (
                  <Grid container spacing={1}>
                    <Typography color="text.primary">{translation.expires}</Typography>
                    <Typography color="text.secondary">{formatDate(card.assignment.expiryDate, 'dateOnly')}</Typography>
                  </Grid>
                )}
                <Grid container spacing={1}>
                  <Typography color="text.primary">{translation.action}</Typography>
                  <Typography color="text.secondary">{getActionArray(card, translation).join(', ')}</Typography>
                </Grid>
                <Grid container spacing={1}>
                  <Typography color="text.primary">{translation.status}</Typography>
                  <Typography color="text.secondary">{getCardStatusesArray(card, translation).join(', ')}</Typography>
                </Grid>
                <Button
                  id={`nfc-card-row-${index}-block-button`}
                  onClick={() => onBlockCard(card.uuid)}
                  color="error"
                  startIcon={<BlockOutlined />}
                >
                  {translation.block_card}
                </Button>
              </Grid>
            </ListItem>
          </List>
        </Grid>
      </Collapse>
    </Grid>
  );
};

export default NfcCardRow;
